export default __webpack_public_path__ + "static/media/avatar_indian_boy6.cf205c61.mp3";